import NoBrandCompanyLogo from 'assets/variants/noBrand/reservifyLogo.png'
import NoBrandLandingBackground from 'assets/variants/noBrand/searchBackground.png'
import { APP_VARIANT_NO_BRAND } from 'constants/app'

export const SPACING_PX = 8

export const commonTheme = {
  spacing: (n: number) => `${n * SPACING_PX}px`,
  fontFamily: {
    regular: '"Encode Sans", sans-serif',
  },
  isKiosk: false,
}

const COLORS_PALETTE = {
  black: '#000000',
  white: '#FFFFFF',
  yellow: 'yellow',
  darkJeans: '#2a4686',
  navyBlue: 'rgba(34, 58, 113, 1)',
  crimsonRed: '#cd2121',
  grayIntrovert: '#9b9b9b',
  graySomething: '#E3E3E3',
  grayTransparent: '#00000080',
  blackyGray: '#30303096',
  greyishBrown: '#545454',
  lightGreyBorder: '#CBCBCB',
  oldGolden: 'rgba(164, 134, 30, 1)',
  gradientBlue: 'linear-gradient(180deg, #2A4686 0%, #3661C4 100%)',
  gradientBluish: 'linear-gradient(106.89deg, #2A4686 11.43%, #000819 161.41%)',
  gradientDark: 'linear-gradient(172.67deg, #292D32 -0.97%, #5E6164 197.52%)',
  reefGold: '#A4861E',
  gallery: '#ECECEC',
  shark: '#292D32',
}

const commonColors = {
  secondary: COLORS_PALETTE.white,
  modalBackground: COLORS_PALETTE.white,
  modalOverlay: COLORS_PALETTE.blackyGray,
  textTertiary: COLORS_PALETTE.white,
  background: COLORS_PALETTE.white,
  gradient: 'linear-gradient(#39598A, #79D7ED)',
  buttonBorder: '#FFF',
  border: COLORS_PALETTE.lightGreyBorder,
  lightBorder: COLORS_PALETTE.greyishBrown,
  tableHeadBackground: COLORS_PALETTE.graySomething,
  cardFront: COLORS_PALETTE.gradientBlue,
  error: COLORS_PALETTE.crimsonRed,
}

const noBrandTheme = {
  ...commonTheme,
  mainFont: 'EncodeSans',
  colors: {
    ...commonColors,
    primary: COLORS_PALETTE.reefGold,
    bar: COLORS_PALETTE.shark,
    text: COLORS_PALETTE.gallery,
    textSecondary: COLORS_PALETTE.greyishBrown,
    textHeader: COLORS_PALETTE.reefGold,
    border: COLORS_PALETTE.greyishBrown,
    cardFront: COLORS_PALETTE.gradientDark,
  },
  assets: {
    companyLogo: NoBrandCompanyLogo,
    hotelLogo: '',
    landingBackground: NoBrandLandingBackground,
    searchBackground: NoBrandLandingBackground,
  },
  params: {
    buttonBorderRadius: '40px',
    imageBorderRadius: '10px',
  },
  texts: {
    reservationSystem: 'our reservation system',
  },
}

export const variantTheme = {
  [APP_VARIANT_NO_BRAND]: noBrandTheme,
}

export type TVariantTheme = typeof noBrandTheme
